(() => {
  "use strict";

  const CARDS = [
    {
      title: "Monitors",
      description: "Gaming, curved, 4K & ultrawide monitors for every setup",
      url: "/collections/gaming-monitors",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Bundles-Silver-Silver.png?v=1786616420",
    },
    {
      title: "Monitor Arms",
      description: "Clamp and desk mounts to declutter your workspace",
      url: "/collections/monitor-arms",
      image:
        "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Bundles-Silver-Silver_1.png?v=1786616420",
    },
  ];

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }

  function main() {
    addStyles();
    addCategoryCards();
  }

  function addStyles() {
    const style = document.createElement("style");
    style.textContent = `
      .ab119CardsSection {
        max-width: 1440px;
      }

      .ab119Cards {
        --ab119-red: #8A0001;
        --ab119-border: #D5D5D5;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        margin: 20px 0 24px;
      }

      .ab119Card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
        max-width: 485px;
        padding: 16px 18px;
        border: 1px solid var(--ab119-border);
        border-radius: 8px;
        background: #FFFFFF;
        color: #111111;
        text-decoration: none;
        transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
      }

      .ab119Card:hover,
      .ab119Card:focus {
        opacity: 1;
        border-color: var(--ab119-red);
        color: #111111;
        text-decoration: none;
      }

      .ab119Card--active {
        border-color: var(--ab119-red);
        box-shadow: inset 0 0 0 1px var(--ab119-red);
        background: #FBECEC;
      }

      .ab119Card__text {
        flex: 1 1 auto;
        min-width: 0;
      }

      .ab119Card__title {
        margin: 0;
        font-size: 18px;
        line-height: 1.25;
        font-weight: 700;
      }

      .ab119Card__desc {
        display: none;
        margin: 6px 0 0 !important;
        font-size: 14px;
        line-height: 1.35;
        color: #333333;
      }

      .ab119Card--active .ab119Card__desc {
        display: block;
      }

      .ab119Card__img {
        flex: 0 0 auto;
        width: 38%;
        max-width: 220px;
        max-height: 100px;
        object-fit: contain;
      }

      @media (min-width: 1024px) {
        .ab119CardsSection {
          padding: 0 10px;
        }

        .ab119Cards {
          flex-direction: row;
          justify-content: flex-start;
          gap: 25px;
          margin: 28px 0 36px;
        }

        .ab119Card {
          flex: 1 1 0;
          min-height: 150px;
          padding: 24px 30px;
        }

        .ab119Card__title {
          font-size: 22px;
        }
      }
      
      @media (min-width: 1200px) {
        .ab119CardsSection {
          padding: 0 2rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function addCategoryCards() {
    const collectionBody = document.querySelector(".collection_body");

    if (!collectionBody || document.querySelector(".ab119Cards")) return;

    const section = document.createElement("div");
    section.className = "ab119CardsSection page-width";

    const wrapper = document.createElement("div");
    wrapper.className = "ab119Cards";

    CARDS.forEach((card) => {
      wrapper.appendChild(buildCard(card));
    });

    section.appendChild(wrapper);
    collectionBody.parentNode.insertBefore(section, collectionBody);
    moveMobileFilterBar(section);
  }

  // monitor-collection-filter.js drops .filter-mobile-topBar after .categoryStickyHeightFix, which lands it
  // above the cards. Both sit in the same parent, so moving it keeps its sticky offset working.
  function moveMobileFilterBar(section) {
    const filterBar = document.querySelector(".filter-mobile-topBar");

    if (!filterBar) return;

    section.after(filterBar);
  }

  function buildCard(card) {
    const isActive = window.location.pathname.replace(/\/$/, "") === card.url;

    const link = document.createElement("a");
    link.className = `ab119Card${isActive ? " ab119Card--active" : ""}`;
    link.href = card.url;

    link.innerHTML = `
      <div class="ab119Card__text">
        <p class="ab119Card__title">${card.title}</p>
        ${card.description ? `<p class="ab119Card__desc">${card.description}</p>` : ""}
      </div>
      <img class="ab119Card__img" src="${card.image}" alt="${card.title}" loading="lazy">
    `;

    link.addEventListener("click", () => {
      document.body.classList.add("loading");
    });

    return link;
  }
})();
